import { gql } from 'apollo-boost';

export const validationErrorGroupFragment = gql`
    fragment ValidationErrorGroup on GdDefect {
        code
        params
        path
        __typename
    }
`;

export const validationWarningGroupFragment = gql`
    fragment ValidationWarningGroup on GdDefect {
        code
        params
        path
        __typename
    }
`;

export const userSettingsDataQuery = gql`
    query UserSettingsDataQuery($login: String!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            measurerAccounts
        }
    }
`;

export const addClientMeasurerAccount = gql`
    mutation addMeasurerAccount($input: GdAddClientMeasurerAccountInput!) {
        reqId: getReqId
        addMeasurerAccount(input: $input) {
            validationResult {
                errors {
                    ...ValidationErrorGroup
                    __typename
                }
                warnings {
                    ...ValidationWarningGroup
                    __typename
                }
                __typename
            }
            __typename
        }
    }

    ${validationErrorGroupFragment}
    ${validationWarningGroupFragment}
`;

export const deleteClientMeasurerAccount = gql`
    mutation deleteMeasurerAccount($measurerSystem: GdClientMeasurerSystemInput!) {
        reqId: getReqId
        deleteMeasurerAccount(measurerSystem: $measurerSystem) {
            validationResult {
                errors {
                    ...ValidationErrorGroup
                    __typename
                }
                warnings {
                    ...ValidationWarningGroup
                    __typename
                }
                __typename
            }
            __typename
        }
    }

    ${validationErrorGroupFragment}
    ${validationWarningGroupFragment}
`;
